// SettingRenderer.js
import React, { useState, useEffect } from 'react';

const SettingRenderer = ({ group, modifiedSettings, handleSettingChange, handleBlur, resetSetting, initialValues, inputStyles, selectStyles, deviceProps }) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        // Automatically open the section if any setting is not equal to its default value
        const hasNonDefaultSettings = group.settings.some(setting => {
            let defaultValue = setting.description?.defaults?.[deviceProps.type_str] || setting.description?.default;

            if (setting.description?.smartphone_display_type === 'checkbox') {
                defaultValue = Number(defaultValue);
            }
            return (!(setting.value == defaultValue)) && setting.isValid;
        });

        if (hasNonDefaultSettings) {
            setIsOpen(true);
        }
    }, [group.settings, deviceProps.type_str]);

    const toggleSection = () => {
        setIsOpen(!isOpen);
    };

    console.log("SettingRenderer / deviceProps", deviceProps);

    return (
        <li>
            <h4
                onClick={toggleSection}
                style={{
                    fontWeight: 'bold',
                    color: '#007bff',
                    paddingTop: '10px',
                    marginLeft: '10px',
                    marginRight: '10px',
                    marginTop: '5px',
                    cursor: 'pointer',
                }}
            >
                {group.name} {isOpen ? '▲' : '▼'}
            </h4>
            {isOpen && (
                group.settings.map((setting, index) => {
                    // Determine the default value based on the device type or fallback to the general default
                    let defaultValue = setting.description?.defaults?.[deviceProps.type_str] || setting.description?.default;
                    const oldValue = initialValues[setting.bleId];

                    let defaultValueStr = defaultValue;
                    if (setting.description?.type.includes('int')) {
                        defaultValueStr = Number(defaultValue).toFixed(0);
                    }
                    if (setting.description?.smartphone_display_type === 'checkbox') {
                        defaultValueStr = (defaultValue == 0) ? 'false' : 'true';
                    }

                    const isEqualToDefault = (setting.value == defaultValue)

                    return (
                        <div key={index} style={{ marginLeft: '10px', marginRight: '10px', marginTop: '8px' }}>
                            <div style={{ fontWeight: 'bold', color: setting.isValid ? 'var(--color-foreground)' : '#777' }}>
                                {setting.description?.smartphone_display_name}
                            </div>
                            <div style={{
                                marginLeft: '14px', color: setting.isValid
                                    ? (isEqualToDefault ? 'var(--color-foreground)' : 'red')
                                    : '#777',

                            }}>
                                Current: {setting.valueStr} / Default: {defaultValueStr}
                            </div>
                            <div style={{ marginTop: '5px', color: '#999' }}>
                                {setting.description?.smartphone_display_type === 'checkbox' ? (
                                    <select
                                        value={modifiedSettings[setting.bleId]?.value ?? setting.valueIndex}
                                        onChange={(e) => handleSettingChange(setting.bleId, e.target.value, setting.valueIndex)}
                                        onBlur={(e) => handleBlur(setting.bleId, setting.valueIndex, e.target.value, e)}
                                        style={{
                                            ...inputStyles,
                                            ...selectStyles,
                                            border: modifiedSettings[setting.bleId]?.type === "blur" ? '1px solid red' : '1px solid #ccc',
                                            width: '70%'
                                        }}
                                    >
                                        <option value="1">true</option>
                                        <option value="0">false</option>
                                    </select>
                                ) : setting.description?.smartphone_display_type === 'list' ? (
                                    <select
                                        value={modifiedSettings[setting.bleId]?.value ?? setting.valueIndex}
                                        onChange={(e) => handleSettingChange(setting.bleId, e.target.value, setting.valueIndex)}
                                        onBlur={(e) => handleBlur(setting.bleId, setting.valueIndex, e.target.value, e)}
                                        style={{
                                            ...inputStyles,
                                            ...selectStyles,
                                            border: modifiedSettings[setting.bleId]?.type === "blur" ? '1px solid red' : '1px solid #ccc',
                                            width: '70%'
                                        }}
                                    >
                                        {setting.description?.list_strings.split('\n').map((option, i) => (
                                            <option key={i} value={i}>
                                                {option}
                                            </option>
                                        ))}
                                    </select>
                                ) : (
                                    <input
                                        type="text"
                                        value={modifiedSettings[setting.bleId]?.value ?? setting.valueStr}
                                        onChange={(e) => handleSettingChange(setting.bleId, e.target.value, setting.valueStr)}
                                        onBlur={(e) => handleBlur(setting.bleId, setting.valueStr, e.target.value, e)}
                                        style={{
                                            ...inputStyles,
                                            border: modifiedSettings[setting.bleId]?.type === "blur" ? '1px solid red' : '1px solid #ccc',
                                            width: '70%'
                                        }}
                                    />
                                )}
                                <button
                                    className="btn btn-sm btn-outline-secondary m-1"
                                    onClick={() => handleSettingChange(setting.bleId, oldValue, setting.valueIndex)}
                                >
                                    Old
                                </button>
                                <button
                                    className="btn btn-sm btn-outline-secondary m-1"
                                    onClick={() => handleSettingChange(setting.bleId, defaultValue, setting.valueIndex)}
                                >
                                    Default
                                </button>
                            </div>

                            {
                                setting.editedAt && setting.editedAt !== 0 && (
                                    <div style={{ color: setting.isValid ? '(var(--color-foreground))' : '#777', marginLeft: '13px' }}>
                                        Edited at: {new Date(setting.editedAt).toLocaleString()}
                                    </div>
                                )
                            }
                        </div>
                    );
                })
            )}
        </li >
    );
};

export default SettingRenderer;
